import { defineQueryOptions } from '@pinia/colada';
import { api, ApiError } from './client.ts';

export const gameInProgressKeys = {
  byCode: (code: number) => ['games', 'open', code] as const,
};

const noGameInProgress = 'game-not-found';

export const gameInProgressQuery = defineQueryOptions((code: number) => ({
  key: gameInProgressKeys.byCode(code),
  query: async (): Promise<boolean> => {
    const { error, response } = await api.GET('/games/{code}', { params: { path: { code } } });
    if (response.ok) return true;
    if (error?.slug === noGameInProgress) return false;
    throw new ApiError(response.status);
  },
}));
